import { Component, Inject, OnInit, Output, EventEmitter } from '@angular/core';
import { IUser } from '@shared/models/login.model';
import { SocketService } from '@shared/services/socket.service';
import { UserService } from '@shared/services/user.service';
import { UnsubscribeOnDestroyAdapter } from 'src/app/core/unsuscribe-adapter/unsuscribe-adapter';
import { environment } from 'src/environments/environment';
import {
  IChatConversation,
  IChatMember,
  IChatMessage,
  IPreviousChats,
  IPreviousChatsList
} from './models/chat.model';

@Component({
  selector: 'app-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.scss']
})
export class ChatComponent extends UnsubscribeOnDestroyAdapter
  implements OnInit {
  private instanceChat: SocketService;

  public members: IChatMember[] = [];
  public recentContacts: IChatMember[] = []; // Only 5;
  public conversations: IChatConversation[] = [];
  public previousConversations: IPreviousChats[] = [];

  public memberSelected: IChatMember;
  public conversationSelected: IChatConversation;

  private user: IUser;

  @Output() emitClose: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() emitNewMessage: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    @Inject(SocketService) socketService: any,
    private userService: UserService
  ) {
    super();
    this.instanceChat = socketService(1);
    this.user = this.userService.userInfo;
  }

  ngOnInit() {
    this.initSocketConnection();
  }

  private initSocketConnection(): void {
    this.instanceChat.initSocket(
      environment.socketUrl + '/chat',
      localStorage.getItem('JWT_TOKEN')
    );
    this.getPreviousChats();
    this.subs.add(
      this.instanceChat.onEvent('private-chat-history').subscribe(e => {
        const index = this.conversations.findIndex(
          conversation => conversation.roomName === e.roomName
        );
        if (index === -1) {
          this.conversations.push({
            roomName: e.roomName,
            total: e.total,
            messages: this.convertHistoryMessages(e.messages, e.roomName),
            opened: false,
            member: this.getMemberWithRoom(e.roomName)
          });
        } else {
          this.conversations[index].messages = this.convertHistoryMessages(
            e.messages,
            e.roomName
          );
          this.conversations[index].total = e.total;
        }
        const conv = this.conversations.filter(c => c.roomName === e.roomName);
        if (!this.memberSelected) {
          this.conversationSelected = conv.length !== 0 ? conv[0] : null;
          if (conv.length > 0) {
            this.members.forEach(member => {
              if (
                conv[0].roomName.indexOf(`:${member.id}-${this.user.id}`) !==
                  -1 ||
                conv[0].roomName.indexOf(`:${this.user.id}-${member.id}`) !== -1
              ) {
                this.memberSelected = member;
              }
            });
            this.emitMessageSeen(
              conv[0].roomName,
              this.previousConversations.findIndex(
                c => c.roomName == conv[0].roomName
              )
            );
          }
        } else {
          if (this.conversationSelected)
            this.conversationSelected =
              conv.length !== 0 &&
              conv[0].roomName == this.conversationSelected.roomName
                ? conv[0]
                : null;
          if (!this.conversationSelected)
            this.conversationSelected = conv.length !== 0 ? conv[0] : null;
        }
      })
    );
    this.subs.add(
      this.instanceChat
        .onEvent('new-message')
        .subscribe((data: IChatMessage) => {
          const index = this.previousConversations.findIndex(
            conversation => conversation.roomName == data.roomName
          );
          const indexC = this.conversations.findIndex(
            conversation => conversation.roomName == data.roomName
          );
          if (index === -1) {
            if (
              this.conversationSelected &&
              this.conversationSelected.roomName == data.roomName
            )
              this.instanceChat.emitEvent('private-chat-history', {
                with: data.originUser.id
              });
            this.previousConversations.push({
              roomName: data.roomName,
              created_at: new Date().toString(),
              lastMessage: data.message,
              unseen: false,
              contact_name:
                data.originUser.name + ' ' + data.originUser.last_name,
              contact_id: data.originUser.id,
              contact_photo: data.originUser.photo,
              on_line: true,
              emitter_id: data.originUser.id,
              unseen_msgs: 1
            });
          } else {
            this.previousConversations[index] = {
              roomName: data.roomName,
              created_at: new Date().toString(),
              lastMessage: data.message,
              unseen:
                this.conversationSelected &&
                this.conversationSelected.roomName == data.roomName
                  ? false
                  : true,
              contact_name:
                data.originUser.name + ' ' + data.originUser.last_name,
              contact_id: data.originUser.id,
              contact_photo: data.originUser.photo,
              on_line: true,
              emitter_id: data.originUser.id,
              unseen_msgs:
                Number(Number(this.previousConversations[index].unseen_msgs)) +
                1
            };
          }
          if (
            this.conversationSelected &&
            this.conversationSelected.roomName == data.roomName
          ) {
            if (indexC === -1) {
              this.instanceChat.emitEvent('private-chat-history', {
                with: data.originUser.id
              });
              this.previousConversations[index] = {
                roomName: data.roomName,
                created_at: new Date().toString(),
                lastMessage: data.message,
                unseen: false,
                contact_name:
                  data.originUser.name + ' ' + data.originUser.last_name,
                contact_id: data.originUser.id,
                contact_photo: data.originUser.photo,
                on_line: true,
                emitter_id: data.originUser.id,
                unseen_msgs:
                  Number(
                    Number(this.previousConversations[index].unseen_msgs)
                  ) + 1
              };
            } else {
              this.conversations[indexC].messages.push(data);
              this.conversations[indexC].total += 1;
              const conv = this.conversations.filter(
                c => c.roomName === data.roomName
              );
              this.conversationSelected = {
                ...(conv.length !== 0 ? conv[0] : null)
              };
              this.previousConversations[index] = {
                roomName: conv[0].roomName,
                created_at: new Date().toString(),
                lastMessage: data.message,
                unseen: this.conversationSelected.roomName == data.roomName,
                contact_name:
                  data.originUser.name + ' ' + data.originUser.last_name,
                contact_id: data.originUser.id,
                contact_photo: data.originUser.photo,
                on_line: true,
                emitter_id: data.originUser.id,
                unseen_msgs:
                  Number(this.previousConversations[index].unseen_msgs) + 1
              };
              if (
                conv[0] &&
                this.memberSelected &&
                this.memberSelected.id == conv[0].member.id
              ) {
                this.emitMessageSeen(
                  conv[0].roomName,
                  this.previousConversations.findIndex(
                    c => c.roomName == conv[0].roomName
                  )
                );
              }
            }
          } else if (indexC !== -1) {
            this.conversations[indexC].messages.push(data);
            this.conversations[indexC].total += 1;
          }
          this.emitNewMessage.emit(true);
        })
    );
    this.subs.add(
      this.instanceChat.onEvent('members').subscribe((data: IChatMember[]) => {
        this.members = data.filter(member => member.id !== this.user.id);
      })
    );
  }

  private convertHistoryMessages(
    incomingMessages: any[],
    room: string
  ): IChatMessage[] {
    const messages: IChatMessage[] = incomingMessages.map(msg => {
      return {
        created_at: msg.created_at,
        destinationUser: null,
        message: msg.message,
        originUser: msg.UserId === this.user.id ? this.user : msg.User,
        roomName: room
      };
    });
    return messages;
  }

  public talkTo(member: IChatMember): void {
    // Select the member
    this.memberSelected = member;
    // Select conversation
    const conv = this.conversations.filter(
      c => c.roomName.indexOf(`:${member.id}-${this.user.id}`) !== -1
    );
    this.conversationSelected = conv.length !== 0 ? conv[0] : null;
    if (!this.conversationSelected) {
      this.instanceChat.emitEvent('private-chat-history', {
        with: member.id
      });
    } else {
      this.emitMessageSeen(
        conv[0].roomName,
        this.previousConversations.findIndex(
          c => c.roomName == conv[0].roomName
        )
      );
    }
    //this.updateRecentContacts();
  }

  public talkToPreviousContact(previousContact: IPreviousChats): void {
    // Select conversation
    const conv = this.conversations.filter(
      c =>
        c.roomName.indexOf(`:${previousContact.contact_id}-${this.user.id}`) !==
        -1
    );
    this.conversationSelected = conv.length !== 0 ? conv[0] : null;
    this.memberSelected = conv.length !== 0 ? conv[0].member : null;
    if (!this.conversationSelected) {
      this.instanceChat.emitEvent('private-chat-history', {
        with: previousContact.contact_id
      });
    } else {
      this.emitMessageSeen(
        previousContact.roomName,
        this.previousConversations.findIndex(
          c => c.roomName == previousContact.roomName
        )
      );
    }
    //this.updateRecentContacts();
  }

  public emitMessage(data: {
    id: number;
    message: string;
    roomName: string;
  }): void {
    this.instanceChat.emitEvent('send-private-message', {
      to: data.id,
      message: data.message
    });
    const index = this.conversations.findIndex(
      conversation => conversation.roomName === data.roomName
    );
    this.conversations[index].total += 1;
    const conv = this.conversations.filter(c => c.roomName === data.roomName);
    this.conversationSelected = {
      ...(conv.length !== 0 ? conv[0] : null)
    };
    const existPreviousChat = this.previousConversations.findIndex(
      conversation => conversation.roomName == conv[0].roomName
    );
    if (existPreviousChat !== -1) {
      this.previousConversations[existPreviousChat].lastMessage = data.message;
      this.previousConversations[existPreviousChat].emitter_id = this.user.id;
      this.previousConversations[existPreviousChat].unseen = false;
      this.previousConversations[
        existPreviousChat
      ].on_line = this.memberSelected.on_line;
      this.previousConversations[
        existPreviousChat
      ].created_at = new Date().toString();
      this.previousConversations[existPreviousChat].unseen_msgs =
        Number(this.previousConversations[existPreviousChat].unseen_msgs) + 1;
    } else {
      this.previousConversations.push({
        roomName: conv[0].roomName,
        created_at: new Date().toString(),
        lastMessage: data.message,
        unseen: false,
        contact_name:
          this.memberSelected.name + ' ' + this.memberSelected.last_name,
        contact_id: this.memberSelected.id,
        contact_photo: this.memberSelected.photo,
        on_line: this.memberSelected.on_line,
        emitter_id: this.user.id,
        unseen_msgs: 1
      });
    }
  }

  public selectConversation(conversation: IPreviousChats): void {
    // Select the member
    //this.memberSelected = member;
    // Select conversation
    const conv = this.conversations.filter(
      c =>
        c.roomName.indexOf(`:${conversation.contact_id}-${this.user.id}`) !== -1
    );
    this.conversationSelected = conv.length !== 0 ? conv[0] : null;
    this.memberSelected = conv.length !== 0 ? conv[0].member : null;
    if (!this.conversationSelected) {
      this.instanceChat.emitEvent('private-chat-history', {
        with: conversation.contact_id
      });
    } else {
      this.emitMessageSeen(
        conv[0].roomName,
        this.previousConversations.findIndex(
          c => c.roomName == conv[0].roomName
        )
      );
    }
    // const conv = this.conversations.filter(
    //   c => c.roomName === conversation.roomName
    // );
    // this.conversationSelected = conv.length !== 0 ? conv[0] : null;
    // this.members.forEach(member => {
    //   if (
    //     conversation.roomName.indexOf(`:${member.id}-${this.user.id}`) !== -1 ||
    //     conversation.roomName.indexOf(`:${this.user.id}-${member.id}`) !== -1
    //   ) {
    //     this.memberSelected = member;
    //   }
    // });
    // this.updateRecentContacts();
  }

  private updateRecentContacts(): void {
    const idx = this.recentContacts.findIndex(
      x => x.id === this.memberSelected.id
    );
    if (idx === -1) {
      if (this.recentContacts.length === 5) {
        this.recentContacts.shift();
      }
      this.recentContacts.push(this.memberSelected);
    }
  }

  private getMemberWithRoom(room: string): IChatMember {
    let mem: IChatMember = null;
    this.members.forEach(member => {
      if (
        room.indexOf(`:${member.id}-${this.user.id}`) !== -1 ||
        room.indexOf(`:${this.user.id}-${member.id}`) !== -1
      ) {
        mem = member;
      }
    });
    return mem;
  }

  getPreviousChats() {
    this.instanceChat.emitEvent('previous-chats', {});
    this.subs.add(
      this.instanceChat
        .onEvent('previous-chats')
        .subscribe((list: IPreviousChatsList) => {
          this.previousConversations = list.chats;
        })
    );
  }

  emitMessageSeen(roomName: string, indexPreviousChat: number) {
    this.instanceChat.emitEvent('mark-as-seen', { roomName: roomName });
    if (indexPreviousChat >= 0) {
      this.previousConversations[indexPreviousChat].unseen = false;
      this.previousConversations[indexPreviousChat].unseen_msgs = 0;
    }
  }
}
